export default {"src":"/_next/static/media/instagram.50e60506.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};